import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";

const PricingSection = () => {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section className="py-20 md:py-28 bg-background" ref={ref}>
      <div className="container max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <h2 className="text-heading md:text-display-sm text-foreground mb-4">
            Simpel prissætning
          </h2>
          <p className="text-lg text-muted-foreground max-w-md mx-auto">
            Én plan med alt inkluderet — ingen skjulte omkostninger.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="rounded-2xl border-2 border-accent bg-card p-8 relative shadow-lg glow-accent max-w-md mx-auto"
        >
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent text-accent-foreground text-xs font-semibold px-3 py-1 rounded-full">
            Alt inkluderet
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-1">MySabbat Pro</h3>
          <p className="text-sm text-muted-foreground mb-5">Fuld adgang til alt</p>
          <div className="flex items-end gap-6 mb-6">
            <div>
              <p className="text-3xl font-bold text-foreground">
                49 kr<span className="text-base font-normal text-muted-foreground">/måned</span>
              </p>
            </div>
            <div className="pb-1">
              <p className="text-sm text-muted-foreground">
                eller <span className="font-semibold text-foreground">199 kr/år</span> (spar 66%)
              </p>
            </div>
          </div>
          <ul className="space-y-3 mb-6">
            {["Personlige anbefalinger", "Budget- & planlægningsværktøjer", "AI-guide til retning", "Udforsk alle muligheder", "Gemte favoritter"].map((f) => (
              <li key={f} className="flex items-center gap-2.5 text-sm text-foreground">
                <Check className="w-4 h-4 text-accent shrink-0" />
                {f}
              </li>
            ))}
          </ul>
          <Button asChild className="w-full rounded-xl bg-accent hover:bg-accent/90 text-accent-foreground">
            <Link to="/waitlist">Kom i gang</Link>
          </Button>
        </motion.div>

        {/* Legal compliance */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={isVisible ? { opacity: 1 } : {}}
          transition={{ delay: 0.5 }}
          className="text-center mt-8 space-y-2"
        >
          <p className="text-xs text-muted-foreground">
            Abonnementet fornyes automatisk. Du kan opsige når som helst.
          </p>
          <div className="flex items-center justify-center gap-4 text-xs text-muted-foreground">
            <Link to="/privacy" className="underline hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <span>·</span>
            <Link to="/terms" className="underline hover:text-foreground transition-colors">
              Terms of Use
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PricingSection;
